import styled from 'styled-components';

const SideBarIcon = styled.i`
    padding: 0px 10px;
    font-size: 15px;
    display: flex;
    min-width: 40px;
    justify-content: center;
    align-items: center;

    .active & {
        color: ${props => props.theme.global.colors.highlightColor}
    }

    @media (max-height: 500px) {
        font-size: 10px;
    }

    @media 
    (min-width: 768px) and (max-width: 992px) and (max-height: 500px)
     {
        width: 65px;
    }
`;

export default SideBarIcon;



// WEBPACK FOOTER //
// ./src/components/atoms/sidebar/SideBarIcon.js